import axios from 'axios';

import { BASE_API_URL } from '../_services';

export const userService = {
    login,
    logout,
    refreshToken,
};

function login(username, password) {
    return axios.post(`${BASE_API_URL}/token/`, {
        email: username, password: password
    }).catch(handleResponse)
        .then(function (response) {
        var user = {
            token:     response.data.access,
            refresh:   response.data.refresh,
            email:     response.data.email,
            name:      response.data.first_name,
            last_name: response.data.last_name,
            full_name: response.data.full_name,
            client_ids: response.data.client_ids,
            is_superuser: response.data.is_superuser,
            is_farm_staff: response.data.is_farm_staff,
            id: response.data.id,
        }
        if (response.data.access) {
            localStorage.setItem('user', JSON.stringify( user ));
        }
        return user;
    })
}

function refreshToken(refresh){
    return axios.post(`${BASE_API_URL}/refresh/token/`, {
        refresh: refresh
    }).catch(handleResponse)
        .then(function (response) {
          return response.data.access;
    })
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}


function handleResponse(error) {
    var response = error.response;
    var data = response.data;
    if (response.status === 400) {
      return Promise.reject(data['non_field_errors'][0])
    }

    if (response.status === 401 || response.status == 403) {
      // auto logout if 401 response returned from api
      logout();
      location.reload(true);
    }
    const errorMessage = (data && data.message) || response.statusText;
    return Promise.reject(errorMessage);
}